import React from "react";
import Text from "components/general/Text";
import Button from "components/general/Button";
import styles from "./styles.module.scss";
import empty_icon from "assets/icons/empty.svg";

interface EmptyStateProps {
  title?: string;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  buttonText?: string;
  onClick?: () => void;
  showBtn?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title = "No Documents Yet",
  description = "You Haven’t Uploaded Any Documents. Upload Leave Sheets, HR Forms, Or Other Files To Get Started.",
  icon = <img src={empty_icon} alt="Empty State" />,
  buttonText = "Import New Leave File",
  onClick,
  showBtn = true,
}) => (
  <div className={styles.container}>
    <div>{icon}</div>
    <div className={styles.textContainer}>
      <Text className={styles.text}>{title}</Text>
      <Text className={styles.description}>{description}</Text>
    </div>
    {showBtn && (
      <Button btnClassName={styles.emptyStateButton} onClick={onClick}>
        {buttonText}
      </Button>
    )}
  </div>
);

export default EmptyState;
